$(function() {
    console.log("Entered")
    var $location = $('#fenix_location');
    var ssid = ''
    if (Cookies.get('__ssid') != null) {
        ssid = document.cookie.split('; __ssid=')[1].split('; ')[0];
        if (!ssid) {
            ssid = ''
        }
    }
    const $fenix = $('#fenix')
    const $qtyField = $('#qty-input')
    const $fenixResponse = $('#fenix-response')
    const $zipDiv = $('#fenix-zip')
    const $zipInpt = $('#zip-inpt')
    const $checkZip = $('#check-zip')
    const $toggleZip = $('#fenix-toggle-zip')
    const $productTags = $('#fenix_tags')
    const $shipMessage = $('#current_variant_shipping_message')
    const $ssid = $('#currentUser_sessionid')
    const $currentInventory=$('#fenix-select')

    var showZipcodeField = !1
    var blank = ''
    
    var {
        product, zipcode, price, sku, page, availableQty, productid, variantid, flag, weight
    } = $fenix.data()
    
  
    
    if (Cookies.get("location") != null) {
        zipcode = Cookies.get("location")
    }
    var locationid = ''
    var quantity = availableQty;

    function toggleZipField() {
        showZipcodeField = !0
        $toggleZip.css('visibility', 'hidden');
        $zipDiv.show('visibility', 'visible')
    }

    function isValidUSZip(sZip) {
        return /^\d{5}(-\d{4})?$/.test(sZip)
    }

    function getZipcode() {
        if (showZipcodeField) {
            const userZip = $zipInpt.val()
            return isValidUSZip(userZip) ? userZip : zipcode
        }
        return zipcode || zipcode
    }


    function getRequestData() {
        return {
            "sessionTrackId": ssid,
            "buyerZipCode": "" + zipcode,
            "monetaryValue": (parseInt(price) / 100).toFixed(2),
            "pageType": page,
            "responseFormat": "json",
            "skus": [{
                "quantity": parseInt(1),
                "sku": sku,
              "weight": { 
                "units": "LB", 
                "value": weight || 1
              },
              
              "dimensions":
              		{ 		
              		 "girth":"2", 
             		 "height":"2", 
              		 "length":"2", 
             		 "units": "IN", 
                      "width": "2"
            		
            	},
              
                "skuInventories": [{
                  "locationId": "manual",
                    "quantity": availableQty,
                }]
            }]
        }
    }
    if ((typeof Cookies.get("location") === 'undefined')) {
      if(flag==true){
      setTimeout(getLocation, 2000)
      }  
        
    } else {
      if(flag==true){
        setTimeout(checkShippingEstimate, 2000)
      }
    }

   
    var onChangeFlag = !0
    var checkShipping = !0

    function checkShippingEstimate() {
        $.ajax({
            type: "POST",
            async: "true",
            url: "https://delest-api.fenixcommerce.com/fenixdelest/api/v2/deliveryestimates",
            data: JSON.stringify(getRequestData()),
            headers: {
                'tenantId': '0f3e7cb2c00240d8813473dc481daeb3 ',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            timeout: 2000
        }).done(function(data) {
            var res = data[0]
            var shippingDate = res.guaranteedDeliveryDate
            res = res.response
            var phrase = createPhraseForDeliveryEstimate(res)
            $fenixResponse.html(phrase)
            if ($ssid) {
                $ssid.val(ssid)
            }
           
            $fenixResponse.css('visibility', 'visible')
            $toggleZip.css("display", "block");
            //addEventListenerOnSelect()
        }).fail(function(error) {
            $fenixResponse.css('visibility', 'hidden')
        })
    }

    function getDataFromString(str, matchExp, start, end) {
        if (str.match(matchExp)) {
            return str.substring(str.match(matchExp).index + start, str.match(matchExp).index + end)
        }
    }

    function createPhraseForDeliveryEstimate(res) {
    	var phrase = res
        phrase = "<span class='deliveryResponse'>" + phrase
        var hours = getDataFromString(res, "Hours", -3, -1)
        var mins = getDataFromString(res, "Minutes", -3, -1)
        var shippingMethod = res.shippingMethodDesc
        if (hours) {
            phrase = phrase.replace("" + hours + " Hours", "<b><span class='timeColor'>" + hours + " Hours</span></b>")
            phrase = phrase.replace("" + mins + " Minutes", "<b><span class='timeColor'>" + mins + " Minutes</span></b>")
        }
        if (phrase.match("Today")) {
            phrase = phrase.replace("Today", "<b><span class='timeColor'>Today</span></b>")
        }
        if (phrase.match("Faster")) {
            phrase = phrase.replace("Faster", "</span><br><span class='deliveryResponseCheckout'> Faster")
        }
        if (phrase.match("Choose")) {
            phrase = phrase.replace("Choose", "</span><br><span class='deliveryResponseCheckout'> Choose")
        }
        var dateString = getDataFromString(res, "Get it by ", 10, 29)
        if (dateString) {
            if (dateString.includes(".")) {
                dateString = dateString.split(".")[0]
            } else {
                dateString = dateString.split(",")[0] + "," + dateString.split(",")[1]
            }
            var afterDate = dateString
            var todayDate = new Date();
            var presentYear = todayDate.getFullYear();
          if(afterDate.match(presentYear)!=null){
            var afterDate = afterDate.substring(0, afterDate.match(presentYear).index + 4)
            phrase = phrase.replace("" + afterDate, "<b>" + afterDate + "</b>")
          }
        }
        phrase = phrase + " to  Zip Code : " + zipcode + "</span>"
        phrase=phrase.replace(".","")
        return phrase
    }

    
    $toggleZip.on('click', toggleZipField)
    $checkZip.on('click', function() {
        if (isValidUSZip($zipInpt.val())) {
            zipcode = $zipInpt.val();
            Cookies.remove('location', {
                path: '/'
            });
            Cookies.set('location', $zipInpt.val(), {
                path: '/'
            });
            $toggleZip.css('visibility', 'hidden');
            $zipDiv.show('visibility', 'hidden');
            checkShippingEstimate()
            
        }
    })
    
    $qtyField.on('change', checkShippingEstimate)
    //find input change event ..how it works...

    function getLocation() {
        var   ipLocation = '';
        const GoogleKey = "AIzaSyA4d5hOMddDPW4dx9W6z-BI3aAX32fcZYo"
        const GoogleUrl = "https://maps.googleapis.com/maps/api/geocode/json?latlng="
        //var   defaultZip = ''

        function Set_Cookie(name, value, path) {
            var today = new Date()
            var zero_date = new Date(0, 0, 0)
            today.setTime(today.getTime() - zero_date.getTime())
            var cookie_expire_date = new Date(today.getTime() + (8 * 7 * 86400000))
            if (name.includes('ssid')) {
                value = btoa(value)
            }
            var cookieString = name + "=" + value + (";expires=" + cookie_expire_date.toGMTString()) + ((path) ? ";path=" + path : "")
            document.cookie = cookieString
        }

        function geoSuccess(position) {
            const lat = position.coords.latitude
            const lng = position.coords.longitude
            $.get(`${GoogleUrl}${lat},${lng}&result_type=postal_code&key=${GoogleKey}`).done((location) => {
              console.log('loc',location)
                ipLocation = location.results[0].address_components[0].short_name
                zipcode = ipLocation
                //flag = !0;
                Cookies.set('location', zipcode, {
                    path: '/'
                })
                checkShippingEstimate()
            }).fail((error) => {
              console.log(error)
                Cookies.set('location', blank, {
                    path: '/'
                })
            })
        }

        function geoError(error) {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    console.log("User denied the request for Geolocation.")
                    break;
                case error.POSITION_UNAVAILABLE:
                    console.log("Location information is unavailable.")
                    break;
                case error.TIMEOUT:
                    console.log("The request to get user location timed out.")
                    break;
                case error.UNKNOWN_ERROR:
                    console.log("An unknown error occurred.")
                    break
            }
            //flag = !0
            $toggleZip.show()
        }
        if (typeof Cookies.get("location") === 'undefined') {
        ipLookUp()
          
        }
        
        function ipLookUp() {
        
            $.ajax('https://ipapi.co/json').then(function success(response) {
                ipLocation = response.postal;
                Set_Cookie("location", ipLocation, "/")
                zipcode = ipLocation
                
                checkShippingEstimate()
            }, function fail(data, status) {
                navigator.geolocation.getCurrentPosition(geoSuccess, geoError, {
                    timeout: 20000
                })
            })
        }
        let ssid = ''
        if (Cookies.get('__ssid') != null) {
            ssid = document.cookie.split('; __ssid=')[1].split('; ')[0];
            if (!ssid) {
                ssid = ''
            }
        } else {
            Set_Cookie("__ssid", Math.random(), "/")
        }
    }
})